import { render, staticRenderFns } from "./StatusSettingsItems.vue?vue&type=template&id=ed25b1a4"
import script from "./StatusSettingsItems.vue?vue&type=script&lang=js"
export * from "./StatusSettingsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports